(ns splash.ui.lender-portal.components.search-box
  (:require
    ["@azure/msal-react" :as msal-react]
    ["react-router-dom" :refer [useHistory]]
    [reagent-mui.icons.search :refer [search]]
    [reagent.core :as r]
    [splash.ui.lender-portal.common.auth :as auth]
    [splash.ui.lender-portal.common.request :as request]
    [splash.ui.lender-portal.components.mui :as mui]
    [splash.ui.lender-portal.components.sidebar-card :refer [sidebar-card]]
    [splash.ui.lender-portal.datadog :as datadog]
    [splash.ui.lender-portal.state :as state]))

(defn input-key->id
  [key]
  (str (name key) "-input"))

(defn search-input
  [input-key search-inputs on-search]
  (r/with-let [error (r/atom nil)]
    [mui/box {:sx {:display         "flex"
                   :alignItems      "center"
                   :flexGrow        1
                   :backgroundColor "white"
                   :padding         "4px 8px"
                   :borderRadius    "4px"
                   :border          "1px solid #DEE8EF"
                   :marginRight     "8px"
                   :marginBottom    "12px"}}
     [mui/text-field {:id         (input-key->id input-key)
                      :variant    :standard
                      :sx         {:minWidth "150px"}
                      :value      (get-in @search-inputs [input-key :value])
                      :helperText @error
                      :error      (some? @error)
                      :on-key-up  #(when (= "Enter" (.-key %))
                                     (on-search))
                      :on-change  (fn [event]
                                    (let [value     (.. event -target -value)
                                          new-value (if (= "" value) nil value)
                                          validator (get-in @search-inputs [input-key :validator])]
                                      (when (fn? validator)
                                        (->> (validator new-value)
                                          (reset! error)))
                                      (swap! search-inputs assoc-in [input-key :value] new-value)))
                      :InputProps {:disable-underline true
                                   :placeholder       (get-in @search-inputs [input-key :label])
                                   :sx                {:fontSize   "14px"
                                                       :marginLeft "8px"}}
                      :full-width true}]]))

(defn get-search-params
  [search-inputs]
  (reduce (fn [acc [input-key {:keys [value parse-fn]}]]
            (if (empty? value)
              acc
              (assoc acc input-key (if (fn? parse-fn)
                                     (parse-fn value)
                                     value))))
    {} @search-inputs))

(defn search-box
  []
  (r/with-let [msal-instance     (.-instance (msal-react/useMsal))
               state             (state/use-state)
               history           (useHistory)
               loading           (r/cursor state [:loading])
               search-results    (r/cursor state [:search-results])
               search-inputs     (r/cursor state [:search-inputs])
               handle-results    (fn [results]
                                   (reset! loading false)
                                   (reset! search-results results))
               mk-search-request (fn [search-params token]
                                   (request/mk-json-request
                                     {:uri           "/api/v2/search"
                                      :token         token
                                      :method        :post
                                      :handler       #(handle-results %)
                                      :error-handler (fn [e]
                                                       (case (:status e)
                                                         404 (handle-results [])
                                                         (datadog/report-error
                                                           "Failed to search for applications"
                                                           e)))
                                      :params        search-params}))
               on-search         (fn []
                                   (let [search-params (get-search-params search-inputs)]
                                     (.push history "/search")
                                     (reset! loading true)
                                     (reset! search-results nil)
                                     (-> (auth/acquire-token msal-instance)
                                       (.then (partial mk-search-request search-params)))))]
    [sidebar-card
     [mui/box
      (for [input-key (keys @search-inputs)]
        ^{:key input-key}
        [search-input input-key search-inputs on-search])
      [mui/button {:variant    "contained"
                   :on-click   on-search
                   :start-icon (r/as-element [search {:xs {:color "#a0a4a8"}}])
                   :disabled   (= {} (get-search-params search-inputs))
                   :sx         {:textTransform "none"
                                :borderRadius  "4px"
                                :padding       "0px 16px"
                                :lineHeight    "24px"
                                :color         "white"
                                :&:hover       {:background-color "black"}}}
       "Search"]]]))
